export default __webpack_public_path__ + "static/media/purpledAlien.f764b008.png";